import Cookies from 'js-cookie';
import { apiAction, logEntry } from '../utils/index';

import {
  GET_SETPOINTS,
  SETPOINTS_IS_LOADING,
  SETPOINTS_MANAGEMENT_ERROR,
  SETPOINTS_SET_CURRENT_PAGE,
  SETPOINTS_SET_PAGE_FILTER,
  SETPOINTS_SET,
  SETPOINTS_UPDATE_SAVE_STATUS,
  SETPOINTS_SET_CHANGE,
  SETPOINTS_SET_FILTERED_RESULTS,
  SETPOINTS_CLEANUP
} from '../constants/index';

import {
  SETPOINTS_MANAGEMENT,
  CREATE_SETPOINTS,
  UPDATE_SETPOINTS,
  DELETE_SETPOINTS
} from '../constants/logs';

const envName = process.env.REACT_APP_ENV_NAME_SHORT;

export const getSetpointsThunk = (modelCategoryId, offset, limit, filter, widgetCode) => dispatch => {
  dispatch(getSetpoints(modelCategoryId, widgetCode));
};

export const getSetpoints = (modelCategoryId, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}/management/setpoints`,
    method: 'GET',
    onLoad: status => setLoadingStatus(status),
    onSuccess: retData => setAllSetpointsListThunk(retData),
    onFailure: err => setSetpointsErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    data: {ModelCategoryId: modelCategoryId},
    widgetcode: widgetCode
  });

export const setAllSetpointsListThunk = retData => dispatch => {
  let messageCode = retData && retData.message;
  let setpoints = (retData && retData.setpoints) || [];
  dispatch(setAllSetpointsList(messageCode, setpoints));
};

export const setAllSetpointsList = (messageCode, setpoints) => ({
  type: GET_SETPOINTS,
  payload: {
    data: {
      setpoints: setpoints,
      isLoading: false,
      displayMessageCode: messageCode,
      showBanner: false
    }
  }
});

export const setLoadingStatus = isLoading => ({
  type: SETPOINTS_IS_LOADING,
  payload: { isLoading: isLoading }
});

export const setSetpointsErrorThunk = err => dispatch => {
  let messageCode = err && err.response && err.response.data && err.response.data.errorMessage;
  messageCode = messageCode && messageCode.replace('[400]=>', '');
  dispatch(setSetpointsError(messageCode, true));
  setTimeout(() => {
    //Hide the banner
    dispatch(setSetpointsError(messageCode, false));
  }, 2500);
};

export const setSetpointsError = (messageCode, status) => {
  return {
    type: SETPOINTS_MANAGEMENT_ERROR,
    payload: {
      data: {
        isOpSuccessfull: false,
        showBanner: status,
        isLoading: false,
        displayMessageCode: messageCode || ''
      }
    }
  };
};

export const setCurrentPage = currentPage => ({
  type: SETPOINTS_SET_CURRENT_PAGE,
  payload: { currentPage }
});

export const setPageFilter = filter => ({
  type: SETPOINTS_SET_PAGE_FILTER,
  payload: { filter }
});

export const describeSetpointsThunk = (SetpointId, modelCategoryId, widgetCode) => dispatch => {
  dispatch(describeSetpoints(SetpointId, modelCategoryId, widgetCode));
};

export const describeSetpoints = (SetpointId, modelCategoryId, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}/management/setpoints`,
    data: {
      SetpointId: SetpointId,
      ModelCategoryId: modelCategoryId
    },
    method: 'GET',
    onLoad: status => setLoadingStatus(status),
    onSuccess: retData => setSetpointsThunk(retData),
    onFailure: err => setSetpointsErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    widgetcode: widgetCode
  });

export const setSetpointsThunk = retData => dispatch => {
  let data = retData.setpoints;
  dispatch(setSetpoints(data));
};

export const setSetpoints = data => ({
  type: SETPOINTS_SET,
  payload: data
});

export const saveSetpointsThunk = (setpoints, widgetCode) => dispatch => {
  let url = '/management/setpoints/save';
  let actionName = setpoints.MarkAsDeleted
    ? DELETE_SETPOINTS
    : setpoints.SetpointId === 0
    ? CREATE_SETPOINTS
    : UPDATE_SETPOINTS;
  let log = logEntry(SETPOINTS_MANAGEMENT, actionName, setpoints);
  dispatch(saveSetpoints(setpoints, url, log, widgetCode));
};

export const saveSetpoints = (setpoints, url, log, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}${url}`,
    method: 'POST',
    onLoad: status => setLoadingStatus(status),
    onSuccess: retData => setSetpointsStatusThunk(retData, setpoints),
    onFailure: err => setSetpointsErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    data: {
      setpoints: setpoints,
      log: log
    },
    widgetcode: widgetCode
  });

export const setSetpointsStatusThunk = (message, setpoints) => dispatch => {
  dispatch(setSetpointsStatus(message, true, false));
  setTimeout(() => {
    //Hide the banner
    dispatch(setSetpointsStatus(message, false, !setpoints.MarkAsDeleted));
  }, 2500);
};

export const setSetpointsStatus = (messageCode, status, redirect) => ({
  type: SETPOINTS_UPDATE_SAVE_STATUS,
  payload: {
    data: {
      isOpSuccessful: true,
      showBanner: status,
      isLoading: false,
      redirect: redirect,
      displayMessageCode: messageCode || ''
    }
  }
});

export const setSetpointsChangeThunk = retData => dispatch => {
  dispatch(setSetpointsChange(retData));
};

export const setSetpointsChange = retData => ({
  type: SETPOINTS_SET_CHANGE,
  payload: retData
});

export const setSetpointsFilteredDataThunk = retData => dispatch => {
  dispatch(setSetpointsFilteredData(retData));
};

export const setSetpointsFilteredData = retData => ({
  type: SETPOINTS_SET_FILTERED_RESULTS,
  payload: retData
});


export const resetSetpointsThunk = retData => dispatch => {
  dispatch(resetSetpoints(retData));
};

export const resetSetpoints = retData => ({
  type: SETPOINTS_CLEANUP,
  payload: retData
});